import { PaginatedVacationBonusQueryVariables } from "@/graphql/__generated__/graphql";
import ValueRangeFilter from "../../Shared/ValueRangeFilter";

interface Props {
  displayAmount: number;
  handleSubmitClick: (_variables?: PaginatedVacationBonusQueryVariables) => void;
}

/**
 * VacationBonusValueRange component for filtering vacation bonus by value ranges
 * Handles both bonusRelative and bonusAbsolute value range filters
 * @param props Component properties
 * @returns JSX element
 */
function VacationBonusValueRange({ displayAmount, handleSubmitClick }: Props) {
  const vacationBonusValueConfig = {
    paginationStateKey: "paginatedVacationBonus" as keyof PaginationState,
    fields: [
      {
        fieldName: "bonusRelative",
        labelKey: "components:filters.vacationbonus.sortfields.bonusrelative",
        inputStyle: "decimal" as const,
        useBasisPoints: true,
        suffix: "%",
        decimalScale: 2,
        placeholder: "0.00"
      },
      {
        fieldName: "bonusAbsolute",
        labelKey: "components:filters.vacationbonus.sortfields.bonusabsolute",
        inputStyle: "currency" as const,
        useBasisPoints: false,
        decimalScale: 2,
        placeholder: "0.00"
      }
    ],
    defaultButtonTextKey: "components:filters.vacationbonus.value",
    buildQueryVariables: (
      displayAmount: number,
      filters: any,
      valueRanges: Record<string, { gte: number | null; lte: number | null }>,
      sort?: any
    ): PaginatedVacationBonusQueryVariables => ({
      first: displayAmount,
      filters: {
        activeFrom: filters.activeFrom || null,
        bonusRelative: valueRanges.bonusRelative,
        bonusAbsolute: valueRanges.bonusAbsolute,
        provinces: filters.provinces || null,
      },
      sort: sort
    }),
    extractFilters: (paginationState: any) => ({
      activeFrom: paginationState.filters?.activeFrom,
      bonusRelative: paginationState.filters?.bonusRelative,
      bonusAbsolute: paginationState.filters?.bonusAbsolute,
      provinces: paginationState.filters?.provinces,
    })
  };

  return (
    <ValueRangeFilter
      displayAmount={displayAmount}
      handleSubmitClick={handleSubmitClick}
      config={vacationBonusValueConfig}
    />
  );
}

export default VacationBonusValueRange;
